import {
    ATTRIBUTE_OPTIONS,
    INTERVAL_OPTIONS,
    OPERATOR_OPTIONS,
    ROUNDING_OPTIONS,
    TAGS_OPTIONS,
    TYPE_OPTIONS,
    VALUE_OPTIONS,
    VISIBILITY_OPTIONS
} from "../misc/constants";
import { Col, Row } from "reactstrap";

import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import useUpsert from "./use-upsert";

const UpsertHealthScore = props => {
    
    const {
        handleModalConfig,
        modalConfig: { isOpen, row }
    } = props;

    const isEdit = !!row._id;

    const { onSubmit, methods, updateLoading, isDirty } = useUpsert({
        ...props,
        isEdit
    });
    const {
        control,
        formState: { errors }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Basic Information",
                desc : "Please provide the basic information for the metrics."
            },
            rightChild: (
                <Row>
                    <Col lg={12}>
                        <InputField
                            errors={errors}
                            id="name"
                            label="Name"
                            name="name"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={12}>
                        <InputField
                            errors={errors}
                            id="desc"
                            type="textarea"
                            label="Description"
                            name="desc"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={INTERVAL_OPTIONS}
                            errors={errors}
                            label="Interval"
                            name="interval"
                            id="interval"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={ROUNDING_OPTIONS}
                            errors={errors}
                            label="Rounding"
                            name="rounding"
                            id="rounding"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={VALUE_OPTIONS}
                            errors={errors}
                            label="Value If No Attribute"
                            name="value_if_no_attribute"
                            id="value_if_no_attribute"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={VALUE_OPTIONS}
                            errors={errors}
                            label="Value If No Event"
                            name="value_if_no_event"
                            id="value_if_no_event"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={4}>
                        <Select
                            options={VISIBILITY_OPTIONS}
                            errors={errors}
                            label="Visibility 360"
                            name="visibility_360"
                            id="visibility_360"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={4}>
                        <Select
                            options={TAGS_OPTIONS}
                            errors={errors}
                            label="Tag"
                            name="tag"
                            id="tag"
                            isClearable
                            control={control}/>
                    </Col>
                    <Col lg={4}>
                        <Select
                            options={TYPE_OPTIONS}
                            errors={errors}
                            label="Type"
                            name="type"
                            id="type"
                            control={control}
                            required/>
                    </Col>
                </Row>
            )
        },
        {
            leftChild: {
                title: "Operations",
                desc : "Please provide the operations for the metrics."
            },
            rightChild: (
                <Row>
                    <Col lg={4}>
                        <Select
                            options={ATTRIBUTE_OPTIONS}
                            errors={errors.operations}
                            label="Attribute"
                            name="operations.attribute"
                            id="attribute"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={4}>
                        <Select
                            options={OPERATOR_OPTIONS}
                            errors={errors.operations}
                            label="Operator"
                            name="operations.operation"
                            id="operation"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={4}>
                        <InputField
                            errors={errors.operations}
                            id="value"
                            label="Value"
                            type="number"
                            name="operations.value"
                            required
                            control={control}/>
                    </Col>
                </Row>
            )
        }
    ];
    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Score`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="fullScreen"
            isDirty={isDirty}
            handleModal={handleModalConfig}
            isOpen={isOpen}/>
    );
};
export default UpsertHealthScore;
